import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Footer from '../components/Footer';

const SUPPORT_EMAIL = 'Support@Novareelhub.com';

const Section = ({ id, title, children }) => (
  <section id={id} className="mb-8">
    <h2 className="text-xl md:text-2xl font-semibold text-white mb-3">{title}</h2>
    <div className="text-white/80 leading-relaxed space-y-3">{children}</div>
  </section>
);

const Terms = () => (
  <div className="bg-[#141414] min-h-screen text-white">
    <div className="px-4 md:px-14 py-6 border-b border-white/10 flex items-center gap-3 max-w-4xl mx-auto">
      <Link to="/" className="p-2 rounded hover:bg-white/10 transition-colors">
        <ArrowLeft className="w-5 h-5" />
      </Link>
      <h1 className="text-2xl md:text-3xl font-extrabold">Terms of Use</h1>
    </div>

    <div className="max-w-4xl mx-auto px-4 md:px-14 py-10">
      <p className="text-sm text-white/60 mb-8">Last updated: 2025</p>

      <Section title="1. Acceptance of Terms">
        <p>By creating an account or using NovaReelTV (“the Service”, “we”, “us”), you agree to be bound by these Terms of Use and our Privacy Policy. If you do not agree, please do not use the Service.</p>
      </Section>

      <Section title="2. Free, Ad-Supported Service">
        <p>NovaReelTV is provided free of charge and is supported by advertising and sponsorship placements. We reserve the right to display advertisements, sponsored content, and promotional banners throughout the app.</p>
      </Section>

      <Section title="3. Account & Profiles">
        <p>You must be at least 13 years old to create an account. Profiles marked as “Kid” automatically filter mature content and disable certain features to protect younger viewers. You are responsible for keeping your account credentials secure.</p>
      </Section>

      <Section title="4. Content Ownership">
        <p>Movie titles, artwork, trailers, and metadata displayed on the Service are the property of their respective rights holders and are used under fair use or via publicly available APIs (e.g., The Movie Database). NovaReelTV does not claim ownership of third-party content.</p>
      </Section>

      <Section title="5. Acceptable Use">
        <p>You agree not to (a) attempt to reverse-engineer the Service, (b) upload malicious code, (c) use the Service for unlawful purposes, or (d) attempt to bypass technical measures. Violations may result in account termination.</p>
      </Section>

      <Section title="6. AI Chatbot (“Your NovaReel Buddy”)">
        <p>Our AI assistant provides movie recommendations and general chat. Responses are generated by third-party language models and may contain inaccuracies. Do not rely on the assistant for medical, legal, or financial advice.</p>
      </Section>

      <Section title="7. Advertising & Sponsorships">
        <p>Sponsorship banners and Google AdSense units appear throughout the Service. NovaReelTV is not responsible for the content of third-party ads. Interested advertisers should contact us at {SUPPORT_EMAIL}.</p>
      </Section>

      <Section title="8. Termination">
        <p>We may suspend or terminate accounts that violate these terms without notice. You may delete your account at any time via the profile menu.</p>
      </Section>

      <Section title="9. Disclaimers">
        <p>The Service is provided “as is” without warranties of any kind. To the fullest extent permitted by law, NovaReelTV disclaims all warranties, express or implied.</p>
      </Section>

      <Section id="legal" title="10. Legal Notices & Governing Law">
        <p>These terms are governed by the laws of the United States. Any disputes shall be resolved in the state and federal courts located therein.</p>
      </Section>

      <Section id="corporate" title="11. Corporate Information">
        <p>NovaReelTV is a product of NovaReel Hub. For business inquiries, contact <a className="underline text-white hover:text-white/80" href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.</p>
      </Section>

      <Section title="12. Changes to These Terms">
        <p>We may update these terms from time to time. Continued use of the Service after changes means you accept the revised terms.</p>
      </Section>

      <div className="mt-10 p-5 bg-white/5 border border-white/10 rounded-lg">
        <p className="text-sm">
          Questions about these terms? Email us at{' '}
          <a className="underline text-white" href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
        </p>
      </div>
    </div>

    <Footer />
  </div>
);

export default Terms;
